export default function AddAccountModal({ onClose, plaidLoading, plaidStatus, onConnect }) {
  return (
    <div
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}
      style={{
        position: "fixed", inset: 0, background: "rgba(0,0,0,0.75)",
        display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000,
      }}
    >
      <div style={{
        background: "var(--bg-card)", border: "1px solid var(--border-strong)", borderRadius: "20px",
        padding: "36px", width: "420px", maxWidth: "90vw", position: "relative",
      }}>
        <button
          onClick={onClose}
          style={{
            position: "absolute", top: "16px", right: "20px",
            background: "none", border: "none", color: "var(--text-muted)",
            fontSize: "22px", cursor: "pointer", lineHeight: 1,
          }}
        >
          ×
        </button>

        <h2 style={{ fontSize: "20px", fontFamily: "'Capsule Sans', sans-serif", fontWeight: "600", marginBottom: "8px", color: "var(--text-primary)" }}>
          Connect a Bank Account
        </h2>
        <p style={{ fontSize: "13px", color: "var(--text-muted)", marginBottom: "24px", fontFamily: "'Capsule Sans', sans-serif" }}>
          Securely link your accounts using Plaid. Your credentials are never stored.
        </p>

        <button
          onClick={onConnect}
          disabled={plaidLoading}
          style={{
            width: "100%", padding: "14px",
            background: plaidLoading ? "#1E2C1E" : "#D4AF37",
            color: plaidLoading ? "var(--text-faint)" : "var(--text-primary)",
            border: "none", borderRadius: "12px",
            fontSize: "15px", fontWeight: "600",
            cursor: plaidLoading ? "default" : "pointer",
            marginBottom: "16px", transition: "background 0.2s",
          }}
        >
          {plaidLoading ? "Connecting…" : "🔗 Connect with Plaid"}
        </button>

        {plaidStatus && (
          <div style={{
            fontSize: "13px",
            color: plaidStatus.startsWith("✅") ? "#52D68A" : "#F87171",
            marginBottom: "12px", textAlign: "center",
          }}>
            {plaidStatus}
          </div>
        )}

        <div style={{ fontSize: "11px", color: "var(--text-muted)", textAlign: "center", fontFamily: "'JetBrains Mono', monospace" }}>
          🔒 Secured by Plaid · Bank-level encryption · 12,000+ banks supported
        </div>
      </div>
    </div>
  );
}
